<qaroni-counter-widget
  icon="person_off"
  linkText="Ver solicitud"
  i18n-linkText
  [count]="$count()"
  [label]="$count() | i18nPlural: pluralMapping"
  (action)="goToRequests()" />
